import React from "react";
import { useAbhaLink } from "../../../context/AbhaLinkContext";

export default function LinkAbhaButton({ patient }) {
  const { openAbhaLink } = useAbhaLink();

  const isLinked = Boolean(
    patient?.isAbhaLinked === true ||
    patient?.isabhalinked === true ||
    patient?.isABHALinked === true ||
    String(patient?.isAbhaLinked).toLowerCase() === "true" ||
    String(patient?.isabhalinked).toLowerCase() === "true" ||
    String(patient?.isABHALinked).toLowerCase() === "true" ||
    (patient?.maskedAbha && String(patient?.maskedAbha).trim() && patient?.maskedAbha !== "N/A") ||
    (patient?.ABHANumber && String(patient?.ABHANumber).trim() && patient?.ABHANumber !== "N/A") ||
    (patient?.abhaNumber && String(patient?.abhaNumber).trim() && patient?.abhaNumber !== "N/A") ||
    (patient?.abhaaddress && String(patient?.abhaaddress).trim()) ||
    (patient?.abhaAddress && String(patient?.abhaAddress).trim()) ||
    (patient?.ABHAAddress && String(patient?.ABHAAddress).trim())
  );

  if (isLinked) {
    const displayAbha =
      patient?.maskedAbha ||
      (patient?.ABHANumber ? `**** ${String(patient.ABHANumber).slice(-4)}` : "") ||
      patient?.formattedAbhaId ||
      "Linked";
    return (
      <span
        style={{
          fontFamily: "monospace",
          fontSize: "12px",
          color: "#0f172a",
          fontWeight: 600,
        }}
      >
        {displayAbha}
      </span>
    );
  }

  const handleClick = (e) => {
    e?.stopPropagation();
    openAbhaLink(patient);
  };

  return (
    <button
      onClick={handleClick}
      style={{ fontSize: "12px" }}
      className="btn btn-primary btn-sm"
    >
      Link ABHA
    </button>
  );
}

